import React, { useState, createContext, useContext } from 'react'

const AppStateContext = createContext()

const AppStateProvider = ({ children }) => {
  const [appInitialized, setAppInitialized] = useState(false)
  const [globalError, setGlobalError] = useState(false)
  const [globalProcessing, setGlobalProcessing] = useState(false)

  return (
    <AppStateContext.Provider value={{
      appInitialized,
      setAppInitialized,
      globalError,
      setGlobalError,
      globalProcessing,
      setGlobalProcessing
    }}>
      {children}
    </AppStateContext.Provider>
  )
}

const AppStateConsumer = ({ children, ...props }) => {
  return (
    <AppStateContext.Consumer {...props}>
      {children}
    </AppStateContext.Consumer>
  )
}

const useAppState = () => useContext(AppStateContext)

export { AppStateProvider, AppStateConsumer, useAppState }
